import axios from "axios";
import Qs from "qs";
//1.创建axios实例
const instance = axios.create({
  // baseURL: "/target_api",
  timeout: 5000,
  method: "post",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
  },
});

// 请求拦截器
// instance.interceptors.request.use(
//   config => {
//     // 请求前
//     // console.log(config.data)
//     const params = new URLSearchParams()
//     for (const key in config.data) {
//       if (config.data.hasOwnProperty(key)) {
//         params.append(key, config.data[key])
//       }
//     }
//     config.data = params
//     return config
//   },
//   error => {
//     // 做一些请求错误
//   }
// )
instance.interceptors.response.use((response) => {
  // console.log(response);

  if (response.data.code === -1) {
    this.$message({
      message: "验证失败，请重新登录！",
      type: "warning",
    });
    setTimeout(() => {
      this.$router.replace({
        path: "/index",
      });
    }, 2000);
  }
  return response;
});
export function request(config) {
  if (!config.upload && config.data && typeof config.data === "object") {
    config.data = Qs.stringify(config.data);
  }

  return instance(config);
}
